module.exports = __webpack_public_path__ + "static/media/ic_operator_t_mobile.53d572f5.svg";